<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitle" id="pub"><span class="bold">Publisher’s note</span></h1>
<p class="center">The publishers would like to thank Jasmine Scott Neale, Alfie McNamara, Jiri Keller, and Liz Steel for their kind consent to appear in this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Publishers.vue?4385f3c4